// src/config/routes.js
//
// Where each app is mounted (Kuestion Separation contract v2.1, §12).
//
// RULE: this file holds the ONLY literal of the Kuestion mount point. Every
// internal link is built with kq(); a search for the quoted path anywhere
// else in src/ should find nothing. On the day Kuestion moves to its own
// host, KUESTION_BASE becomes '/' and nothing else changes.
//
// It lives in config/, not inside the Kuestion app, because the landing page
// and the shared auth pages need it too and no app may import another app's
// internals (§12 rule 4).

export const KUESTION_BASE = '/kuestion';

const trimmedBase = KUESTION_BASE === '/' ? '' : KUESTION_BASE.replace(/\/+$/, '');

/** Absolute in-app path inside the Kuestion area: kq() → base, kq('login') → base/login. */
export const kq = (path = '') => {
  const p = String(path).replace(/^\/+/, '');
  return p ? `${trimmedBase}/${p}` : (trimmedBase || '/');
};

/** The part of a pathname after the mount point, without slashes at either end. */
export const kqRel = (pathname = '') => {
  let p = String(pathname);
  if (trimmedBase && (p === trimmedBase || p.startsWith(`${trimmedBase}/`))) p = p.slice(trimmedBase.length);
  return p.replace(/^\/+|\/+$/g, '');
};

/** Pattern for mounting the area's router: the base plus a splat today, a bare splat on its own host. */
export const KUESTION_MOUNT = `${trimmedBase}/*`;

/** What a person is told to type — the two user-facing lines on the product and login pages. */
export const KUESTION_PUBLIC_ADDRESS = `riftworks.tech${trimmedBase}`;

// Storage namespaces (§3, §5.2). Same origin now means shared localStorage, so
// "separate login" is something this code does, not something the browser
// enforces: each area reads only its own keys. This is a user-experience
// separation, NOT a security boundary.
export const STORAGE_NS = { kuestion: 'rw.kuestion', suite: 'rw.suite' };
export const storageKey = (area, name) => `${STORAGE_NS[area] || STORAGE_NS.suite}.${name}`;
